import * as types from './types'
import labels from 'common/labels'
import { CONTENT } from 'common/endpoints'
import { fetchAccount } from '../account/actions'
import { fetchBasicRegistry } from '../registry/actions'

// Not an action - just request settings
export const labelsRequest = locale => ({
  url: `${CONTENT.LABELS}?${locale ? `lc=${locale}&` : ''}keepPrefix=1`,
  method: 'POST',
  data: Object.values(labels),
})

export const fetchLabels = locale => ({
  type: types.FETCH_LABELS,
  meta: {
    ...labelsRequest(locale),
    onSuccess: [fetchAccount(), fetchBasicRegistry()],
  },
})

export const fetchStaticPage = ({ pathname, key }) => ({
  type: types.FETCH_STATIC_PAGE,
  key,
  meta: { url: CONTENT.page(pathname) },
})
